import React from "react";
import HexCanvas from "../../components/hexcanvas/HexCanvas";

const SocialMedia = () => {
  return (
    <>
      <HexCanvas title={`Social Media`} />

      <section className="socialmedia">
        <div className="container">
          <div
            className="row align-items-center"
            style={{ marginTop: "-10px" }}
          >
            <div className="col-lg-4 col-sm-4 col-4 p-0 d-flex justify-content-end">
              <img
                src={require("../../images/brands/blissfestive1.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <div className="position-relative">
                <img
                  src={require("../../images/brands/brandmockup.png")}
                  className="img-fluid blissmiddle"
                  alt=""
                />
                <img
                  src={require("../../images/brands/blissfestive3.png")}
                  className="img-fluid blissfestive3"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <img
                src={require("../../images/brands/blissfestive2.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
          </div>
           <div
            className="row align-items-center position-relative"
            style={{ marginTop: "180px" }}
          >
            <div className="col-lg-4 col-sm-4 col-4 p-0 d-flex justify-content-end">
              <img
                src={require("../../images/brands/aqua1.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <div className="position-relative">
                <img
                  src={require("../../images/brands/brandmockup.png")}
                  className="img-fluid blissmiddle"
                  alt=""
                />
                 <img
                  src={require("../../images/brands/aqua2.png")}
                  className="img-fluid blissfestive3"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <img
                src={require("../../images/brands/aqua3.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
          </div>

          <div className="row align-items-center mt-5 position-relative">
            <img
              src={require("../../images/brands/yogagrid.png")}
              className="img-fluid w-100"
              alt=""
            />
          </div>

          <div
            className="row align-items-center position-relative"
            style={{ marginTop: "180px" }}
          >
            <div className="col-lg-4 col-sm-4 col-4 p-0 d-flex justify-content-end">
              <img
                src={require("../../images/brands/blissbarish1.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <div className="position-relative">
                <img
                  src={require("../../images/brands/brandmockup.png")}
                  className="img-fluid blissmiddle"
                  alt=""
                />
                 <img
                  src={require("../../images/brands/blissbarish2.png")}
                  className="img-fluid blissfestive3"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <img
                src={require("../../images/brands/blissbarish3.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
          </div>

          <div
            className="row align-items-center position-relative"
            style={{ marginTop: "180px" }}
          >
            <div className="col-lg-4 col-sm-4 col-4 p-0 d-flex justify-content-end">
              <img
                src={require("../../images/brands/lifespaces-1.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <div className="position-relative">
                <img
                  src={require("../../images/brands/brandmockup.png")}
                  className="img-fluid blissmiddle"
                  alt=""
                />
                 <img
                  src={require("../../images/brands/lifespaces-2.png")}
                  className="img-fluid blissfestive3"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <img
                src={require("../../images/brands/lifespaces-3.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
          </div>


          <div
            className="row align-items-center position-relative"
            style={{ marginTop: "180px" }}
          >
            <div className="col-lg-4 col-sm-4 col-4 p-0 d-flex justify-content-end">
              <img
                src={require("../../images/brands/hillside1.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <div className="position-relative">
                <img
                  src={require("../../images/brands/brandmockup.png")}
                  className="img-fluid blissmiddle"
                  alt=""
                />
                 <img
                  src={require("../../images/brands/hillside2.png")}
                  className="img-fluid blissfestive3"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <img
                src={require("../../images/brands/hillside3.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
          </div>

          <div
            className="row align-items-center position-relative"
            style={{ marginTop: "180px" }}
          >
            <div className="col-lg-4 col-sm-4 col-4 p-0 d-flex justify-content-end">
              <img
                src={require("../../images/brands/bnb1.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <div className="position-relative">
                <img
                  src={require("../../images/brands/brandmockup.png")}
                  className="img-fluid blissmiddle"
                  alt=""
                />
                 <img
                  src={require("../../images/brands/bnb2.png")}
                  className="img-fluid blissfestive3"
                  alt=""
                />
              </div>
            </div>
            <div className="col-lg-4 col-sm-4 col-4 p-0">
              <img
                src={require("../../images/brands/bnb3.png")}
                className="img-fluid blissfestive"
                alt=""
              />
            </div>
          </div>


      
        </div>
      </section>
    </>
  );
};

export default SocialMedia;
